/* imods-cb.js — Clean Bench round, stage 1 (2026-10-21; owner: "let's adopt the whole package at once"). Behaviour of the package's
   header: the desktop menus (snippets/imods-cb-nav.liquid: standard mega panels or iPod screens), the phone menu
   (snippets/imods-cb-drawer.liquid) and the My iPod chip, bar and picker (snippets/imods-cb-picker.liquid). Every menu is a native
   <details> and every item a real link, so all of it works without this file (A-4); this adds hover intent, one menu at a time, Esc
   with focus return, the scrim, the iPod drill-down and preview, the touch rule S10 and the ?panel= deep links. "My iPod" is the
   site's existing "Your iPod" memory (assets/imods-core.js imods.yours, this visit only, D-11 A). Loads after imods-core.js. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  root.classList.add('cb-js');
  var DESK = window.matchMedia('(min-width: 1120px)');
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function I() { return window.imods || {}; }
  var lastPointer = 'mouse';
  doc.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

  // ---- scrim: one shared layer under the open menu / drawer / picker
  var scrim = doc.createElement('div');
  scrim.className = 'cb-scrim'; scrim.hidden = true; scrim.setAttribute('aria-hidden', 'true');
  doc.body.appendChild(scrim);
  var scrimOwner = null;
  function showScrim(owner, top, z) { scrimOwner = owner; scrim.style.top = (top || 0) + 'px'; scrim.style.zIndex = z || 25; scrim.hidden = false; }
  function hideScrim(owner) { if (!owner || scrimOwner === owner) { scrim.hidden = true; scrimOwner = null; } }
  scrim.addEventListener('click', function () { if (scrimOwner && scrimOwner.close) scrimOwner.close(); });

  function headerBottom() { var h = $('.section-header'); var r = h ? h.getBoundingClientRect() : null; return r ? Math.max(0, Math.round(r.bottom)) : 0; }

  // ---- iPod screens (desktop panel and phone drill-down): one list shown at a time, drill in on rows with children, Back returns
  function screens(host) {
    var bar = $('[data-cb-title]', host), back = $('[data-cb-back]', host), prev = $('.ipm-prev', host);
    var all = $$('[data-cb-screen]', host), stack = [];
    function byId(id) { return all.filter(function (s) { return s.id === id; })[0]; }
    function preview(row) {
      if (!prev || !row) return;
      var id = row.getAttribute('data-cb-row');
      $$('.ipm-row.is-on', host).forEach(function (r) { if (r !== row) r.classList.remove('is-on'); });
      row.classList.add('is-on');
      $$('.ipp', prev).forEach(function (c) { c.classList.toggle('is-on', (' ' + c.getAttribute('data-cb-prev') + ' ').indexOf(' ' + id + ' ') >= 0); });
    }
    function show(id, dir, focusRow) {
      var s = byId(id); if (!s) return;
      all.forEach(function (x) { x.classList.toggle('is-on', x === s); x.classList.toggle('is-back', x === s && dir === 'back'); });
      if (bar) bar.textContent = s.getAttribute('data-title') || '';
      if (back) back.hidden = !s.getAttribute('data-parent');
      var first = $('.ipm-row', s);
      if (prev) preview(first);
      if (focusRow && first) first.focus();
    }
    function reset() { stack = []; if (all[0]) show(all[0].id); }
    host.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.ipm-row');
      if (a && host.contains(a)) {
        var to = a.getAttribute('data-cb-open');
        if (to) { e.preventDefault(); stack.push(a.closest('[data-cb-screen]').id); show(to, 'in', true); return; }
        // S10 on touch: the first tap on a row with a preview shows it, the second opens the page
        if (prev && lastPointer === 'touch' && !a.classList.contains('is-on')) { e.preventDefault(); preview(a); }
        return;
      }
      if (e.target.closest && e.target.closest('[data-cb-back]')) { e.preventDefault(); goBack(); }
    });
    function goBack() {
      var cur = all.filter(function (s) { return s.classList.contains('is-on'); })[0];
      var to = stack.pop() || (cur && cur.getAttribute('data-parent'));
      if (to) { show(to, 'back', true); }
    }
    host.addEventListener('keydown', function (e) {
      var a = e.target.closest && e.target.closest('a.ipm-row'); if (!a) return;
      var rows = $$('.ipm-row', a.closest('[data-cb-screen]')), i = rows.indexOf(a), k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowUp') { e.preventDefault(); var n = rows[(i + (k === 'ArrowDown' ? 1 : rows.length - 1)) % rows.length]; n.focus(); }
      else if (k === 'Home' || k === 'End') { e.preventDefault(); rows[k === 'Home' ? 0 : rows.length - 1].focus(); }
      else if (k === 'ArrowRight' && a.getAttribute('data-cb-open')) { e.preventDefault(); a.click(); }
      else if (k === 'ArrowLeft' && back && !back.hidden) { e.preventDefault(); goBack(); }
    });
    if (prev) {
      host.addEventListener('focusin', function (e) { var a = e.target.closest && e.target.closest('a.ipm-row'); if (a) preview(a); });
      var hi = I().hoverIntent;
      if (hi) hi(host, 'a.ipm-row', preview, { pane: function () { return prev; }, side: 'right' });
      else host.addEventListener('mouseover', function (e) { var a = e.target.closest && e.target.closest('a.ipm-row'); if (a) preview(a); });
    }
    reset();
    return { reset: reset, show: show };
  }

  // ---- desktop menus: hover intent (rest 120 ms to open, 250 ms grace to leave), one at a time, Esc, focus out, outside click, scrim
  function initNav() {
    var nav = $('[data-cb-nav]'); if (!nav) return;
    var menus = $$('details[data-cb-mega]', nav), openT = null, closeT = null;
    var ipods = new Map();
    menus.forEach(function (d) { var h = $('[data-cb-ipm]', d); if (h) ipods.set(d, screens(h)); });
    function setTop() { root.style.setProperty('--cb-panel-top', headerBottom() + 'px'); }
    function closeAll(except) { menus.forEach(function (d) { if (d !== except && d.open) d.open = false; }); }
    var owner = { close: function () { closeAll(); } };
    menus.forEach(function (d) {
      var sum = $('summary', d);
      d.addEventListener('toggle', function () {
        if (d.open) {
          closeAll(d); setTop();
          if (ipods.get(d)) ipods.get(d).reset();
          if (DESK.matches) { doc.body.classList.add('cb-menu-open'); showScrim(owner, headerBottom(), 20); }
        } else if (!menus.some(function (x) { return x.open; })) { hideScrim(owner); doc.body.classList.remove('cb-menu-open'); }
        sum.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      });
      sum.setAttribute('aria-expanded', 'false');
      var li = d.parentElement;
      li.addEventListener('mouseenter', function () {
        if (lastPointer === 'touch' || !DESK.matches) return;
        clearTimeout(closeT); clearTimeout(openT);
        var anyOpen = menus.some(function (x) { return x.open; });
        openT = setTimeout(function () { if (!d.open) d.open = true; }, anyOpen ? 60 : 120);
      });
      li.addEventListener('mouseleave', function (e) {
        clearTimeout(openT);
        if (lastPointer === 'touch') return;
        var to = e.relatedTarget;
        if (to && (d.contains(to) || (to.closest && to.closest('[data-cb-nav]')))) return;
        closeT = setTimeout(function () { d.open = false; }, 250);
      });
      d.addEventListener('focusout', function () { setTimeout(function () { if (d.open && !d.contains(doc.activeElement)) d.open = false; }, 0); });
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var d = menus.filter(function (x) { return x.open; })[0];
      if (d) { e.preventDefault(); d.open = false; $('summary', d).focus(); }
    });
    doc.addEventListener('click', function (e) { if (!nav.contains(e.target)) closeAll(); });
    DESK.addEventListener('change', function () { closeAll(); });
    return { open: function (key) { var d = menus.filter(function (x) { return x.getAttribute('data-cb-mega') === key; })[0]; if (d) d.open = true; return d; } };
  }

  // ---- phone menu: a left sheet; Esc, close button, scrim, focus kept inside while open
  function initDrawer() {
    var dr = $('[data-cb-drawer]'); if (!dr) return;
    var sum = $('summary', dr), panel = $('[data-cb-drawer-panel]', dr), ipd = $('[data-cb-ipd]', dr), scr = ipd ? screens(ipd) : null;
    var owner = { close: function () { dr.open = false; } };
    dr.addEventListener('toggle', function () {
      sum.setAttribute('aria-expanded', dr.open ? 'true' : 'false');
      doc.body.classList.toggle('cb-drawer-open', dr.open);
      doc.body.classList.toggle('im-drawer-open', dr.open);   // the theme hides the chat button while a menu sheet is open (G-04)
      if (dr.open) { showScrim(owner, 0, 45); if (scr) scr.reset(); var f = $('a, button, input, summary', panel); if (f) f.focus(); }
      else { hideScrim(owner); }
    });
    var x = $('[data-cb-drawer-close]', dr); if (x) x.addEventListener('click', function () { dr.open = false; sum.focus(); });
    doc.addEventListener('keydown', function (e) {
      if (!dr.open) return;
      if (e.key === 'Escape' && !e.defaultPrevented && !$('[data-cb-picker]:not([hidden])')) { dr.open = false; sum.focus(); return; }
      if (e.key === 'Tab') {
        var f = $$('a[href], button:not([hidden]), input, summary', panel).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    DESK.addEventListener('change', function (m) { if (m.matches) dr.open = false; });
    return {
      open: function (key) {
        dr.open = true;
        if (scr) { scr.show('cbp-' + key); return; }
        var s = $('details[data-cb-sec="' + key + '"]', dr); if (s) s.open = true;
      }
    };
  }

  // ---- My iPod: chip (computers), bar (phones), picker; reads and writes imods.yours
  function initMyIpod() {
    var dlg = $('[data-cb-picker]'); if (!dlg) return;
    var tiles = $$('[data-cb-pick]', dlg), opener = null;
    function cur() { var y = I().yours && I().yours.get(); return y && y.key ? y : null; }
    function tileOf(k) { return tiles.filter(function (t) { return t.getAttribute('data-cb-pick') === k; })[0]; }
    function render() {
      var y = cur(), t = y ? tileOf(y.key) : null;
      // the chip and the bar show the short name (the package's "Classic 7th Gen"); rows and cards keep the site's full name
      $$('[data-cb-yours-label]').forEach(function (el) {
        var short = el.closest('.cb-chip-my, .cb-mybar, .drw-my, [data-cb-yours-row]');
        el.textContent = y ? (short ? y.label.replace(/^iPod /, '') : y.label) : (el.closest('.cb-mybar') ? 'not picked yet' : 'Select your iPod');
      });
      $$('[data-cb-yours-act]').forEach(function (el) { el.textContent = y ? 'Change' : 'Select'; });
      // 2026-10-23 (owner): the visitor's own iPod as the owner's individual picture of that model (imods.fronts) where Files hold it;
      // no iPod picked yet (or no picture) = the neutral iPod line icon (the package's model drawings were scrapped as inaccurate)
      var pic = y && t && I().fronts ? I().fronts(y.key) : null;
      $$('[data-cb-yours-img]').forEach(function (im) {
        if (pic) { var u = pic.replace(/([?&])width=\d+/, '$1width=96'); if (im.getAttribute('src') !== u) im.setAttribute('src', u); im.hidden = false; }
        else im.hidden = true;
      });
      $$('[data-cb-yours-none]').forEach(function (el) { el.hidden = !!pic; });
      $$('.cb-chip-my, .drw-my, [data-cb-mybar]').forEach(function (el) { el.hidden = false; });
      tiles.forEach(function (b) { b.setAttribute('aria-pressed', y && b.getAttribute('data-cb-pick') === y.key ? 'true' : 'false'); });
      var fg = $('[data-cb-pick-forget]', dlg); if (fg) fg.hidden = !y;
      $$('[data-cb-nav] [data-k], [data-cb-drawer] [data-k]').forEach(function (a) { a.classList.toggle('is-yours', !!y && a.getAttribute('data-k') === y.key); });
      // homepage model tiles (sections/imods-cb-models.liquid): the visitor's iPod outlined, with its "My iPod" badge
      $$('[data-cb-mtile]').forEach(function (a) {
        var mine = !!y && a.getAttribute('data-k') === y.key, b = $('[data-cb-mine]', a);
        a.classList.toggle('is-mine', mine); if (b) b.hidden = !mine;
      });
      $$('[data-cb-yours-card]').forEach(function (c) {
        var fit = $('[data-cb-yours-fit]', c), go = $('[data-cb-yours-go]', c), pick = $('[data-cb-pick-open]', c), line = $('[data-cb-yours-line]', c);
        if (y && t) {
          $('[data-cb-yours-fit-t]', c).textContent = 'Fits your ' + y.label.replace(/^iPod /, '');
          fit.hidden = false; pick.hidden = true; go.hidden = false;
          go.href = t.getAttribute('data-parts'); go.textContent = 'Shop ' + y.label.replace(/^iPod /, '') + ' parts';
          line.textContent = 'Every part on that page fits your ' + y.label + '.';
        } else {
          fit.hidden = true; go.hidden = true; pick.hidden = false;
          line.textContent = 'Pick your iPod to see every part that fits it.';
        }
      });
      $$('[data-cb-yours-row]').forEach(function (li) {
        li.hidden = !(y && t);
        var a = $('a', li); if (a && t) { a.href = t.getAttribute('data-parts'); }
      });
      // product pages (sections/imods-product.liquid, the package's fit box): "Fits your <model>" when the visitor's iPod is this page's
      // model; a warning naming the page's model, with a link to their own iPod's parts, when it is another; nothing before they pick
      $$('[data-cb-fit]').forEach(function (box) {
        var k = box.getAttribute('data-k'), a = $('[data-cb-fit-a]', box), ico = $('[data-cb-fit-ico]', box);
        if (!(y && t)) { box.hidden = true; return; }
        var mine = y.key === k;
        box.hidden = false; box.classList.toggle('warn', !mine);
        if (ico) ico.setAttribute('href', mine ? '#cbi-check' : '#cbi-alert');
        $('[data-cb-fit-t]', box).textContent = mine ? 'Fits your ' + y.label : 'This is for the ' + box.getAttribute('data-for');
        $('[data-cb-fit-s]', box).textContent = mine ? 'Model ' + box.getAttribute('data-no') + '.' : 'Your iPod: ' + y.label + '.';
        if (mine) { a.setAttribute('data-cb-pick-open', ''); a.setAttribute('href', '#'); a.textContent = 'Change model'; }
        else { a.removeAttribute('data-cb-pick-open'); a.setAttribute('href', t.getAttribute('data-parts')); a.textContent = 'See parts for your iPod'; }
      });
    }
    function open(from) {
      opener = from || doc.activeElement; dlg.hidden = false; doc.body.classList.add('cb-picker-open');
      var y = cur(), f = (y && tileOf(y.key)) || tiles[0]; if (f) f.focus();
    }
    function close() { dlg.hidden = true; doc.body.classList.remove('cb-picker-open'); if (opener && opener.focus) opener.focus(); }
    doc.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-cb-pick-open]');
      if (o) { e.preventDefault(); open(o); return; }
      if (dlg.hidden) return;
      if (e.target === dlg || (e.target.closest && e.target.closest('[data-cb-pick-close]'))) { close(); return; }
      var t = e.target.closest && e.target.closest('[data-cb-pick]');
      if (t) { I().yours && I().yours.set({ key: t.getAttribute('data-cb-pick'), label: t.getAttribute('data-label') }); close(); return; }
      if (e.target.closest && e.target.closest('[data-cb-pick-forget]')) { I().yours && I().yours.clear(); close(); }
    });
    doc.addEventListener('keydown', function (e) {
      if (dlg.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = $$('button:not([hidden]), a[href]', dlg); if (!f.length) return;
        if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    doc.addEventListener('imods:yours', render);
    render();
  }

  // ---- ?panel= deep links (they opened the old menus): create = Shop iPods, parts = Parts & kits, services = Repair my iPod. On a phone
  // only services opens the menu (as before: the old drawer opened its Repair section); the builder page reads ?panel=create itself.
  function deepLink(nav, drawer) {
    var q = new URLSearchParams(location.search), panel = q.get('panel');
    if (!panel || /^\/collections\/ipods-for-sale/.test(location.pathname)) return;
    var key = { create: 'shop', parts: 'parts', services: 'repair' }[panel]; if (!key) return;
    if (DESK.matches) { if (nav) nav.open(key); }
    else if (key === 'repair' && drawer) { drawer.open('repair'); }
  }

  function ready(fn) { if (doc.readyState !== 'loading') fn(); else doc.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var nav = initNav(), drawer = initDrawer();
    initMyIpod();
    deepLink(nav, drawer);
  });
})();
